import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const cardDataArr = [
  {
    gradient: "from-[#f9d29d] via-[#f1b86e] to-[#e8a969]",
    image: "https://codia-f2c.s3.us-west-1.amazonaws.com/image/2025-08-11/073BGe2dNZ.png",
    icons: ["/assets/images/icons/like.svg", "/assets/images/icons/save.svg", "/assets/images/icons/add.svg"],
    title: "Foaming Face Wash",
    desc: "A refreshing oil-free foaming wash that clears pores, removes excess oil & prevents blemishes.",
    button: "Face",
  },
  {
    gradient: "from-[#e8e6f1] via-[#d9d2e6] to-[#cdc7dd]",
    image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/675c196739659c4-vitamin-c-serum.webp",
    icons: ["/assets/images/icons/like.svg", "/assets/images/icons/save.svg", "/assets/images/icons/add.svg"],
    title: "Vitamin C Serum",
    desc: "Brightens skin tone & reduces hyperpigmentation with potent antioxidant protection.",
    button: "General",
  },
  {
    gradient: "from-[#f2b37d] via-[#d89b61] to-[#c58348]",
    image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/1e86f01693daa63-shampoo.webp",
    icons: ["/assets/images/icons/like.svg", "/assets/images/icons/save.svg", "/assets/images/icons/add.svg"],
    title: "Shampoo",
    desc: "Gentle treatment shampoo designed for seborrhoeic dermatitis of the scalp.",
    button: "Hair",
  },
  {
    gradient: "from-[#8a6dde] via-[#6b4fb5] to-[#5f40a1]",
    image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/af56120bbcf4d06-antibacterial-hydrating-essence-spray.webp",
    icons: ["/assets/images/icons/like.svg", "/assets/images/icons/save.svg", "/assets/images/icons/add.svg"],
    title: "Anti-Bacterial Hydrating Essence Spray",
    desc: "Infused with antibacterial agents & Hyaluronic Acid, this essence spray hydrates & protects skin.",
    button: "Body",
  },
];

const Card = ({ data }) => {
  const [activeIcon, setActiveIcon] = React.useState(null);

  return (
    <div
      className={`relative w-full h-[520px] rounded-3xl shadow-lg overflow-hidden flex flex-col
                  bg-gradient-to-br ${data.gradient} group transition-all duration-500 hover:-translate-y-3 hover:shadow-2xl`}
    >
      {/* Top Half White Background for Image */}
      <div className="w-full h-1/2 bg-white flex items-center justify-center overflow-hidden">
        <img
          src={data.image}
          alt={data.title}
          className="h-[80%] object-contain transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Icon Buttons */}
      <div className="absolute top-5 right-5 flex flex-col gap-4">
        {data.icons.map((icon, i) => (
          <button
            key={i}
            onClick={() => setActiveIcon(i)}
            className={`w-10 h-10 rounded-full backdrop-blur-md shadow-md flex items-center justify-center 
                        transition-all duration-300 ${
                          activeIcon === i
                            ? "bg-[#5F40A1]"
                            : "bg-white/70 hover:bg-[#5F40A1]/90"
                        }`}
          >
            <img
              src={icon}
              alt="icon"
              className={`w-5 h-5 transition-colors duration-300 ${
                activeIcon === i ? "invert brightness-100" : "opacity-90"
              }`}
            />
          </button>
        ))}
      </div>

      {/* Text */}
      <div className="px-6 flex flex-col items-center text-center gap-4 mt-4 flex-grow">
        <h3 className="text-xl font-bold text-white drop-shadow-md">{data.title}</h3>
        <p className="text-sm text-white/90 leading-relaxed line-clamp-3">{data.desc}</p>
      </div>

      {/* CTA */}
      <div className="px-6 block m-w-[100px] mt-8 w-full flex justify-center">
      <Link
        to="/recommendations"
        className="flex justify-center mb-6 w-full px-8 py-3 rounded-full bg-white/20 backdrop-blur-md border border-white/40 text-white font-medium shadow-md 
                   transition-all duration-300 hover:bg-white hover:text-[#5f40a1]"
      >
        {data.button}
      </Link>
      </div>
    </div>
  );
};



const CardData = () => {
  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1.1,
    slidesToScroll: 1,
  };

  return (
    <main className="mx-auto  max-w-7xl">
      {/* Header */}
      <div className="w-full bg-gradient-to-br from-[#2D1735] via-[#2D1735] to-[#5F40A1] rounded-3xl p-10 flex flex-col lg:flex-row items-center relative overflow-hidden shadow-2xl">
        {/* Decorative glow */}
        {/* <div className="absolute top-20 -left-20 w-64 h-64 bg-[#e8a969]/30 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#5f40a1]/30 rounded-full blur-3xl" /> */}

          <div
            className="w-full lg:w-1/2 h-[220px] bg-contain bg-center bg-no-repeat relative z-10"
            style={{
              backgroundImage: "url(https://codia-f2c.s3.us-west-1.amazonaws.com/image/2025-08-11/ofcXDc386E.png)",
            }}
          />
        {/* CTA */}
          <Link
            to="/recommendations"
            className="hidden lg:block absolute right-12 top-1/2 -translate-y-1/2 border border-[#e8a969] rounded-full px-10 py-4
                      text-[#e8a969] text-xl font-semibold transition-all duration-300 hover:bg-[#e8a969] hover:text-[#2c1734] shadow-md"
          >
            View recommendations
          </Link>
          {/* Mobile CTA */}
          <div className="block lg:hidden mt-8 w-full flex justify-center z-10">
            <Link
              to="/recommendations"
              className="border border-[#e8a969] rounded-full px-8 py-3 text-[#e8a969] text-lg font-semibold
                        transition-all duration-300 hover:bg-[#e8a969] hover:text-[#2c1734] shadow-md"
            >
              View recommendations
            </Link>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:grid grid-cols-4 gap-8 mt-12">
        {cardDataArr.map((card, i) => (
          <Card key={i} data={card} />
        ))}
      </div>

      {/* Mobile Layout */}
      <div className="block lg:hidden px-4 mt-12">
        <Slider {...sliderSettings}>
          {cardDataArr.map((card, i) => (
            <div key={i} className="px-2">
              <Card data={card} />
            </div>
          ))}
        </Slider>
      </div>
    </main>
  );
};

export default CardData;
